import { render, staticRenderFns } from "./UiBreadcrumbs.vue?vue&type=template&id=45a8caa4&scoped=true&"
import script from "./UiBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./UiBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./UiBreadcrumbs.vue?vue&type=style&index=0&id=45a8caa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a8caa4",
  null
  
)

export default component.exports